import React, { useState, useEffect } from "react";
import ProvidentLayout from "../../components/ProvidentLayout.js";
import { Row, Col, Button, Modal, Form } from "react-bootstrap";
import { GiTakeMyMoney } from "react-icons/gi";
import axios from "axios";
import "./provident-fund.css";

const rowsPerPage = 10;

const ProvidentFund = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const [employeeName, setEmployeeName] = useState(null);
  const [pfId, setPfId] = useState(null);
  const [userId, setUserId] = useState(localStorage.getItem("userId")); // Get userId from localStorage

  // Log session storage and API data for debugging
  useEffect(() => {
    const storedPfId = localStorage.getItem("pfId");
    const storedName = localStorage.getItem("name");
    console.log("Local Storage Values - userId:", userId, "pfId:", storedPfId, "name:", storedName);

    if (userId) {
      setLoading(true);
      setError(null);

      // Fetch PF data from API
      axios
        .get(`https://backend.ems.uk.hiradentallab.com/api/pf/${userId}`)
        .then((response) => {
          console.log("Full API Response:", response.data); // Log full response

          if (response.status === 200 && response.data?.data) {
            const pfData = [response.data.data]; // Make it an array to render in table

            // Store in state
            setData(pfData);

            // Update PF ID and Name from API data
            if (!storedPfId || !storedName) {
             localStorage.setItem("pfId", pfData[0]?.pfId);
             localStorage.setItem("name", pfData[0]?.name);
              setPfId(pfData[0]?.pfId);
              setEmployeeName(pfData[0]?.name);
            }
          } else {
            setError("No PF data found.");
          }
        })
        .catch((error) => {
          console.error("Error fetching PF data:", error);
          setError("Failed to fetch data. Please try again.");
        })
        .finally(() => setLoading(false));
    } else {
      setError("User ID is missing. Please log in.");
    }
  }, [userId]);

  // Handle modal show
  const handleShowModal = (item) => {
    console.log("Selected Item for Withdrawal:", item);
    setSelectedItem(item);
    setWithdrawAmount(item?.eightyPercent || 0);

    const storedPfId = localStorage.getItem("pfId");
    const storedName = localStorage.getItem("name");

    if (storedPfId && storedName) {
      setPfId(storedPfId);
      setEmployeeName(storedName);
    } else {
      alert("PF ID or Name is missing. Please log in again.");
      return;
    }

    setShowModal(true);
  };

  // Handle request submission
  const handleRequest = () => {
    console.log("PF ID:", pfId, "Name:", employeeName); // Log PF ID and Name
    if (!userId || !pfId || !employeeName) {
      alert("User ID, Provident Fund ID, or Name is missing. Please log in again.");
      return;
    }

    const requestData = {
      userId,
      pfId,
      name: employeeName,
      amountRequested: withdrawAmount,
    };

    console.log("Request Data:", requestData); // Log request data before sending

    axios
      .post(
        `https://backend.ems.uk.hiradentallab.com/pf-requests/withdraw/${userId}`,
        requestData
      )
      .then((response) => {
        console.log("API Response:", response); // Log API response
        alert("Withdrawal request submitted successfully.");
        handleCloseModal(); // Close modal after request
      })
      .catch((error) => {
        console.error("Error:", error); // Log error
        alert(
          "Error: " + error.response?.data?.message || "Please try again later."
        );
      });
  };

  // Handle modal close
  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Pagination logic
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(data.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  // Pagination handling
  const currentData =
    data.length > 0
      ? data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
      : [];

  return (
    <ProvidentLayout>
      <h1 className="provident-fund-title">
        <GiTakeMyMoney className="provident-fund-icon" /> Provident Fund
      </h1>
      <hr />
      <div className="provident-fund-table-container">
        <div className="entries-search-container" style={{ marginTop: 0 }}>
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center">
              {/* Show Entries Dropdown */}
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end">
              {/* Search Form */}
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <table className="table table-striped provident-fund-table">
            <thead>
              <tr>
                <th>SR</th>
                <th>Name</th>
                <th>Total Amount</th>
                <th>Available for Withdraw</th>
                <th>Withdraws Available</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    {error}
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.balance}</td>
                    <td>{item.eightyPercent}</td>
                    <td>{item.withdrawalsAvailable}</td>
                    <td>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleShowModal(item)}
                      >
                        Action
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No data available now
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="pagination-container">
            <Button
              variant="secondary"
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Prev
            </Button>
            {pageRange().map((page) => (
              <Button
                key={page}
                variant={currentPage === page ? "primary" : "secondary"}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Button>
            ))}
            <Button
              variant="secondary"
              disabled={currentPage === Math.ceil(data.length / rowsPerPage)}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Next
            </Button>
          </div>

          {/* Modal for withdrawal request */}
          <Modal show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Request Withdrawal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group>
                  <Form.Label>
                    Available Amount: {selectedItem?.eightyPercent}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={withdrawAmount}
                    onChange={(e) => setWithdrawAmount(Number(e.target.value))}
                    max={selectedItem?.eightyPercent || 0}
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Close
              </Button>
              <Button variant="primary" onClick={handleRequest}>
                Submit Request
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </ProvidentLayout>
  );
};

export default ProvidentFund;
